import styled from 'styled-components';

export const RadioContainer = styled.div`
    margin: 8px;
    display: inline-block;
`;

interface IRadioLabel {
    disabled?: boolean;
}

export const RadioLabel = styled.label<IRadioLabel>`
    color: ${(props) => (props.disabled ? '#ccc' : '#000')};
    font-size: 0.875rem;
`;
